"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardFilterPeriods = void 0;
exports.dashboardFilterPeriods = [
    { label: "Current Month", value: "current_month" },
    { label: "Last Month", value: "previous_month" },
    { label: "Last 30 Days", value: "30" },
    { label: "Last 90 Days", value: "90" },
];
